import { render, staticRenderFns } from "./TabsWidget.vue?vue&type=template&id=274fcfb7&scoped=true&"
import script from "./TabsWidget.vue?vue&type=script&lang=js&"
export * from "./TabsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TabsWidget.vue?vue&type=style&index=0&id=274fcfb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274fcfb7",
  null
  
)

export default component.exports